import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ArrowRightIcon, SearchIcon } from 'lucide-react';
import { services } from '../data/services';
export const NotFoundPage: React.FC = () => {
  const internalServices = services.filter(service => !service.external);
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans flex flex-col" data-id="element-1675" data-mp="36sm1lcvebtfw">
      <SEO title="Deze pagina bestaat niet | Noord Digital" description="De pagina die je zocht bestaat niet of is verplaatst. Bekijk onze diensten of ga terug naar de homepage van Noord Digital." canonical="https://noorddigital.nl/" noindex data-id="element-1676" data-mp="31v3t1nlajg8f" />
      <Header data-id="element-1677" data-mp="1mdae01x8lsn3" />

      <main className="flex-grow" data-id="element-1678" data-mp="1mcs9ki0f8843">
        <section className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px] pt-32 pb-20 md:pt-40 md:pb-24" data-id="element-1679" data-mp="1me3lx67xmo6t">
          <div className="max-w-3xl" data-id="element-1680" data-mp="1hgk11ngqbd5w">
            <span className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-[#EEF5FA] text-[#004AC7] mb-6" data-id="element-1681" data-mp="wcimeugbavta">
              <SearchIcon className="h-7 w-7" aria-hidden="true" data-id="element-1682" data-mp="10edo4025nb7l" />
            </span>
            <p className="text-[#6B7280] font-semibold mb-3" data-id="element-1683" data-mp="15cf3a9wgmqds">Foutcode 404</p>
            <h1 className="font-bold text-[#111827] text-4xl md:text-5xl leading-tight mb-6" data-id="element-1684" data-mp="1a33yo0b9g7i7">
              Deze pagina bestaat niet
            </h1>
            <p className="text-[#4B5563] text-lg leading-relaxed mb-10" data-id="element-1685" data-mp="1f1ynbivwsqa8">
              De link is verouderd of er staat een typefout in het adres. Via
              onderstaande pagina's kom je alsnog waar je wilde zijn.
            </p>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10" data-id="element-1686" data-mp="1t29fqqcvacxi">
              {internalServices.map(service => <li key={service.title} data-id="element-1687" data-mp="3pvbbl6wd6ece">
                  <Link to={service.link} className="group flex items-center justify-between gap-4 rounded-xl border border-gray-200 p-5 hover:border-[#004AC7] transition-colors duration-200" data-id="element-1688" data-mp="3pwcm9a9gwytl">
                    <span className="font-semibold text-[#111827]" data-id="element-1689" data-mp="x0t8q874gxl7">
                      {service.title}
                    </span>
                    <ArrowRightIcon className="h-4 w-4 text-[#004AC7] flex-shrink-0 transform group-hover:translate-x-1 transition-transform duration-200" aria-hidden="true" data-id="element-1690" data-mp="1b1dqr257qpdn" />
                  </Link>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4" data-id="element-1691" data-mp="1fwt4lu380la2">
              <Link to="/" className="inline-flex items-center justify-center bg-[#004AC7] hover:bg-[#003A9E] text-white font-semibold py-4 px-8 rounded-lg transition-colors duration-200 shadow-md" data-id="element-1692" data-mp="1tp8zu8pvrf0f">
                Naar de homepage
              </Link>
              <Link to="/sitemap" className="inline-flex items-center justify-center border border-gray-300 text-[#111827] font-semibold py-4 px-8 rounded-lg hover:border-[#004AC7] hover:text-[#004AC7] transition-colors duration-200" data-id="element-1693" data-mp="1yqg6u5k78a61">
                Bekijk alle pagina's
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1694" data-mp="2daspjxkfij0y" />
    </div>;
};